const commonHeaders = {
  'Content-Type': 'application/json',
  'x-selected-language': getMeta('selected-language') || 'en'
}

function getMeta(metaName) {
  const metas = document.getElementsByTagName('meta');

  for (let i = 0; i < metas.length; i++) {
    if (metas[i].getAttribute('name') === metaName) {
      return metas[i].getAttribute('content');
    }
  }

  return null;
}

export default {
  namespaced: true,
  state() {
    return {
      modelBuilds: [],
      srcModelBuilds: [],
      selectedBuild: null,
      zoomBuild: null,
      zoomGroups: [],
      zoomTitles: [],
      notRedirectFromZoom: false,
      extra: [],
      compareBuild1: null,
      compareBuild2: null,
      compareBuild3: null,
      steps: {
        1: {
          active: true,
          completed: false
        },
        2: {
          active: false,
          completed: false
        },
        3: {
          active: false,
          completed: false
        },
        4: {
          active: false,
          completed: false
        },
        5: {
          active: false,
          completed: false
        },
        6: {
          active: false,
          completed: false
        },
        7: {
          active: false,
          completed: false
        },
      },
      modelList: [],
      preselected: [],
      selectorLoading: false,
      titleList: [],
      colorGroupsList: [],
      sizesList: [],
      extraList: [],
      selectedModel: null,
      selectedBuildTitle: null,
      selectedColor: null,
      selectedSize: null,
      selectedPaymentOption: 'full',
      customColor: null,
      motoStyle: false,
      vatConfirm: false
    }
  },
  actions: {
    getBuild(context, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/v2/builds/card',
          method: 'POST',
          data: data,
          headers: {...commonHeaders, ...{"Accept": "application/json"}}
        }).then(res => {
          resolve(res.data.data)
        }).catch(err => {
          console.log("Error while update preselected", err)
          reject(err)
        })
      })
    },
    gallery() {
      return new Promise((resolve, reject) => {
        axios({
          url: '/en/gallery/builds',
          method: 'GET',
          headers: {...commonHeaders, ...{"Accept": "application/json"}}
        }).then(res => {
          resolve(res.data.data)
        }).catch(err => {
          console.log("Error while update preselected", err)
          reject(err)
        })
      })
    },
    updatePreselected({getters}) {
      let preselected = getters.preselected

      return new Promise((resolve, reject) => {
        let url = '/en/choose';

        if (preselected.model.selected) {
          url += `/${preselected.model.selected.slug}`

          if (preselected.title.selected) {
            url += `/${preselected.title.selected.slug}`

            if (preselected.color.selected) {
              url += `/${preselected.color.selected.slug}`

              if (preselected.size.selected) {
                url += `/${preselected.size.selected.slug}`
              }
            }

            // if (preselected.brakes.selected) {
            //   url += `/${preselected.brakes.selected.slug}`
            //
            //   if (preselected.color.selected) {
            //     url += `/${preselected.color.selected.slug}`
            //
            //     if (preselected.size.selected) {
            //       url += `/${preselected.size.selected.slug}`
            //     }
            //   }
            // }
          }
        }

        axios({
          url: url + "?json=true",
          method: 'GET',
          headers: {...commonHeaders, ...{"Accept": "application/json"}}
        }).then(res => {
          resolve(res.data.data)
        }).catch(err => {
          console.log("Error while update preselected", err)
        })
      })
    },
    selectModel({commit, dispatch}, data) {
      return new Promise((resolve, reject) => {
        let url = `${data.path}/v2/models/${data.model.id}/titles`;
        axios({
          url,
          method: 'GET',
          headers: commonHeaders
        }).then(result => {
          commit('setTitles', result.data.titles)
          if (data.buildPreselect) {
            let title = result.data.titles.find(item => {
              return item.build['build_title'].id === data.defaultBuild['build_title'].id
            })
            if (title) {
              commit('setSelectedTitle', title)
              dispatch('selectTitle', {
                path: data.path,
                title: title,
                model: data.model
              }).then((response) => {
                if (data.colorPreselect) {
                  let group = response.data.groups.find(item => {
                    return item.id === data.defaultBuild['color']['group_id']
                  })
                  if (group) {
                    let color = group.colors.find(item => {
                      return item.id === data.defaultBuild.color.id
                    })
                    if (color) {
                      commit('setSelectedColor', color)
                      dispatch('selectColor', {
                        path: data.path,
                        model: data.model,
                        title: title,
                        color: color,
                      }).then(sizeResponse => {
                        if (data.sizePreselect) {
                          let size = sizeResponse.data.sizes.find(item => {
                            return item.id === data.defaultBuild.size.id
                          })
                          if (size) {
                            commit('setSelectedSize', size)
                            dispatch('selectSize', {
                              path: data.path,
                              model: data.model
                            }).then(() => {
                              this._vm.$root.$emit('sizeChanged')
                              resolve()
                            }).catch(error => {
                              console.log(error)
                              reject(error)
                            })
                          }
                        }
                      }).catch(error => {
                        console.log(error)
                        reject(error)
                      })
                    }
                  }
                }
                resolve()
              }).catch((err) => {
                reject(err)
              })
            }
          } else {
            resolve()
          }
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    selectTitle({commit}, data) {
      return new Promise((resolve, reject) => {
        let url = `${data.path}/v2/models/${data.model.id}/titles/${data.title.id}/colors`;
        axios({
          url,
          method: 'GET',
          headers: commonHeaders
        }).then(result => {
          commit('setColorGroups', result.data.groups.filter(item => {
            return item.title.toLowerCase().indexOf('custom') === -1
          }))
          let customGroups = result.data.groups.filter(item => {
            return item.title.toLowerCase().indexOf('custom') !== -1
          });
          if (customGroups.length > 0) {
            commit('setCustomColor', customGroups[0].colors[0])
          }
          resolve(result)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    selectColor({commit}, data) {
      return new Promise((resolve, reject) => {
        let url = `${data.path}/v2/models/${data.model.id}/titles/${data.title.id}/colors/${data.color.id}/sizes`;
        axios({
          url,
          method: 'GET',
          headers: commonHeaders
        }).then(result => {
          commit('setSizes', result.data.sizes)
          resolve(result)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    selectSize({commit}, data) {
      return new Promise((resolve, reject) => {
        let url = `${data.path}/v2/models/${data.model.id}/extra`;
        axios({
          url,
          method: 'GET',
          headers: commonHeaders
        }).then(result => {
          commit('setExtraList', result.data.extra)
          resolve()
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    addToBasket(context, data) {
      let url = `${data.path}/v2/baskets`;
      if (localStorage.getItem('basket_id')) {
        if (!isNaN(parseInt(localStorage.getItem('basket_id')))) {
          url += `/${localStorage.getItem('basket_id')}`
        }
      }
      let headers = {
        'Content-Type': 'application/json'
      };
      return new Promise((resolve, reject) => {
        console.log(data)
        axios({
          url: url,
          method: "POST",
          data: {
            build: data.build.id,
            purchase_type: data.purchase_type,
            extra: data.extra,
            custom_color: data.custom_color,
            moto_style: data.moto_style,
          },
          headers: headers
        }).then(result => {
          localStorage.setItem('basket_id', result.data['basket_id'])
          resolve(result.data)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    loadModelBuilds({commit}, data) {
      let url = `${data.path}/v2/models/${data.model.id}/builds`;
      let headers = {
        'Content-Type': 'application/json'
      };
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: "GET",
          headers: headers
        }).then(result => {
          commit('setModelBuildsList', result.data)
          resolve(result.data)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    }
  },
  mutations: {
    setVatConfirm(state, value) {
      state.vatConfirm = value
    },
    setCustomColor(state, status) {
      state.customColor = status
    },
    setModelList(state, models) {
      state.modelList = models
    },
    setPreselected(state, data) {
      state.preselected = data
    },
    setSelectorLoading(state, value) {
      state.selectorLoading = value
    },
    setMotoStyle(state, value) {
      state.motoStyle = value
    },
    setSelectedBuild(state, build) {
      state.selectedBuild = build
    },
    setSelectedModel(state, model) {
      if (state.preselected.model.selected === null || state.preselected.model.selected.id !== model.id) {
        state.preselected.model.selected = model
        state.preselected.build = state.preselected.model.builds[model.id]
      }
    },
    setActiveAndCompleted(state, step) {
      state.steps[step].active = false;
      state.steps[step].completed = true;
    },
    setSelectedTitle(state, title) {
      if ((state.preselected?.title?.selected || null) === null || state.preselected.title.selected.id !== title.id) {
        state.preselected.title.selected = title
        state.preselected.build = state.preselected.title.builds[title.id]
      }
    },
    setSelectedBrakes(state, brakes) {
      if ((state.preselected?.brakes?.selected || null) === null || state.preselected.brakes.selected.slug !== brakes.slug) {
        state.preselected.brakes.selected = brakes
      }
    },
    setSelectedColor(state, color) {
      if ((state.preselected?.color?.selected || null) === null || state.preselected.color.selected.id !== color.id) {
        state.preselected.color.selected = color
        state.preselected.build = state.preselected.color.builds[color.id]
      }
    },
    setSelectedSize(state, size) {
      if ((state.preselected?.size?.selected || null) === null || state.preselected.size.selected.id !== size.id) {
        state.preselected.size.selected = size
        state.preselected.build = state.preselected.size.builds[size.id]
      }
    },
    setSelectedPaymentOptions(state, type) {
      state.selectedPaymentOption = type
    },
    changeStep(state, data) {
      state.steps[data.from].active = false
      state.steps[data.from].completed = true
      let diff = data.to - data.from
      for (let i = 1; i < diff; i++) {
        state.steps[data.from + i].active = false
        state.steps[data.from + i].completed = true
      }
      if (state.steps[data.to] && !state.steps[data.to].completed) {
        state.steps[data.to].active = true
        state.steps[data.to].completed = false
      }
    },
    resetStepTo(state, step) {
      for (let key of Object.keys(state.steps)) {
        key = parseInt(key)
        if (key < step) {
          state.steps[key].active = false
          state.steps[key].completed = true
        } else if (key === step) {
          state.steps[key].active = true
          state.steps[key].completed = false
        } else {
          state.steps[key].active = false
          state.steps[key].completed = false
        }
      }
      switch (step) {
        case 1:
        case 2:
          state.selectedBuildTitle = null
          state.selectedColor = null
          state.selectedSize = null
          state.selectedPaymentOption = null
          state.extra = []
          break;
        case 3:
          state.selectedColor = null
          state.selectedSize = null
          state.selectedPaymentOption = null
          state.extra = []
          break;
        case 4:
          state.selectedSize = null
          state.selectedPaymentOption = null
          state.extra = []
          break;
      }
      state.selectedPaymentOption = 'full'
    },
    setTitles(state, titles) {
      state.titleList = titles
    },
    setColorGroups(state, groups) {
      state.colorGroupsList = groups
    },
    setSizes(state, sizes) {
      state.sizesList = sizes
    },
    setExtraList(state, extra) {
      state.extraList = extra
    },
    pushToExtra(state, pedal) {
      state.extra.push(pedal)
    },
    removePedalsFromExtra(state) {
      state.extra = state.extra.filter(item => {
        return item['sub_category'] !== 'Pedals'
      })
    },
    selectCompareBuild(state, data) {
      state[`compareBuild${data.type}`] = data.build
    },
    addExtraToBuild(state, item) {
      let exist = state.extra.find(extra => {
        return extra.id === item.id
      })

      if (!exist) {
        state.extra.push(item)
      }
    },
    removePedal(state) {
      state.extra = state.extra.filter(extra => {
        return extra['sub_category'].title !== 'Pedals'
      })
    },
    removeExtraFromBuild(state, item) {
      state.extra = state.extra.filter(extra => {
        return extra.id !== item.id
      })
    },
    resetSelectedBuild(state) {
      state.selectedBuild = null
      state.vatConfirm = false
    },
    setBuildForZoom(state, build) {
      build.media.images = build.media.images.sort((a, b) => {
        return a.id - b.id
      })
      state.zoomBuild = build
    },
    setBuildGroups(state, groups) {
      state.zoomGroups = groups
    },
    setBuildTitles(state, titles) {
      state.zoomTitles = titles
    },
    setNotRedirectFromZoom(state, value) {
      state.notRedirectFromZoom = value
    },
    setBuildByModel(state, model) {
      let build = state.srcModelBuilds.find(item => {
        return item['model_id'] === model.id
      })

      if (build) {
        state.selectedBuild = build
      } else {
        state.selectedBuild = null
      }
    },
    setBuildByColor(state, data) {
      let build = state.srcModelBuilds.find(item => {
        return item.color.id === data.color.id
          && item['model_id'] === data.model.id
      })
      if (build) {
        state.selectedBuild = build
      }
    },
    setBuildBySize(state, data) {
      let build = state.srcModelBuilds.find(item => {
        return item.size.id === data.size.id
          && item.color.id === data.color.id
          && item['model_id'] === data.model.id
      })
      if (build) {
        state.selectedBuild = build
      }
    },
    setBuildByBuilds(state, build) {
      for (let id of build.ids) {
        let build = state.srcModelBuilds.find(item => {
          return item.id === id
        })
        if (build) {
          state.selectedBuild = build
          break;
        }
      }
    },
    setModelBuildsList(state, list) {
      state.srcModelBuilds = list
      let builds = []
      for (let build of list) {
        let exist = builds.find(item => {
          return item.title === build.title.title
        })
        let existIndex
        if (!exist) {
          let max = 0
          builds.map(item => {
            if (item.id > max) {
              max = item.id
            }
          })
          builds.push({
            id: max + 1,
            title: build.title.title,
            cost: build['prices']['price_for_eu'] / 100,
            colorGroups: [],
            sizes: [build.size],
            ids: [build.id]
          })
        } else {
          existIndex = builds.findIndex(item => {
            return item.title === build.title.title
          })
          builds[existIndex].ids.push(build.id)
        }

        if (!existIndex) {
          existIndex = builds.findIndex(item => {
            return item.title === build.title.title
          })
        }

        let existSize = builds[existIndex].sizes.find(item => {
          return item.id === build.size.id
        })

        if (!existSize) {
          builds[existIndex].sizes.push(build.size)
        }

        let existColorGroup = builds[existIndex].colorGroups.find(item => {
          return item.id === build.color.group.id
        })

        if (!existColorGroup) {
          builds[existIndex].colorGroups.push({
            id: build.color.group.id,
            title: build.color.group.title,
            colors: [{
              id: build.color.id,
              title: build.color.title,
              price: build.color.price,
              image: build.color.image,
            }]
          })
        } else {
          let existColorGroupIndex = builds[existIndex].colorGroups.findIndex(item => {
            return item.id === build.color.group.id
          })

          let existColor = builds[existIndex].colorGroups[existColorGroupIndex].colors.find(item => {
            return item.id === build.color.id
          })

          if (!existColor) {
            builds[existIndex].colorGroups[existColorGroupIndex].colors.push({
              id: build.color.id,
              title: build.color.title,
              price: build.color.price,
              image: build.color.image,
            });
          }
        }
      }

      builds = builds.sort((a, b) => {
        return a.cost - b.cost
      })

      state.modelBuilds = builds
    }
  },
  getters: {
    motoStyle(state) {
      return state.motoStyle
    },
    vatConfirm(state) {
      return state.vatConfirm
    },
    notRedirectFromZoom(state) {
      return state.notRedirectFromZoom
    },
    compareBuild1(state) {
      return state.compareBuild1
    },
    compareBuild2(state) {
      return state.compareBuild2
    },
    compareBuild3(state) {
      return state.compareBuild3
    },
    customColor(state) {
      return state.customColor
    },
    modelsForChoose(state) {
      if (typeof state.modelList === 'object') {
        return Array.from(state.modelList)
      }
      return state.modelList
    },
    selectedBuild(state) {
      return state.selectedBuild
    },
    selectedModel(state) {
      return state.selectedModel
    },
    stepList(state) {
      return state.steps
    },
    titleList(state) {
      return state.titleList
    },
    selectedBuildTitle(state) {
      return state.selectedBuildTitle
    },
    colorGroupsList(state) {
      return state.colorGroupsList
    },
    selectedColor(state) {
      return state.selectedColor
    },
    sizesList(state) {
      return state.sizesList
    },
    selectedSize(state) {
      return state.selectedSize
    },
    extraList(state) {
      return state.extraList
    },
    extra(state) {
      return state.extra
    },
    selectedPaymentOption(state) {
      return state.selectedPaymentOption
    },
    preselected(state) {
      return state.preselected
    },
    selectorLoading(state) {
      return state.selectorLoading
    }
  }
}
